// extracted by mini-css-extract-plugin
export default {"card-item":"HZWW5","main":"eiPps","banner-card":"q5ogC","title":"ldy5b"};